// extracted by mini-css-extract-plugin
module.exports = {"container":"newThreadBox_container__H-N4U","header":"newThreadBox_header__19Z9v","buttons":"newThreadBox_buttons__1mx-v","close":"newThreadBox_close__GNCid"};